/**
 * Created by dmitry on 08.10.2025
 */

cleverapps.InitByFeature["minigame"] = function (isNewUser) {
    cleverapps.miniGame = new cleverapps.MiniGame(isNewUser);
};